<template>
	<div class="page-wrapper">
		<div class="page-content">
			<div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
				<div class="breadcrumb-title pe-3">Newsletter Banner CMS</div>
				<div class="ps-3">
					<nav aria-label="breadcrumb">
						<ol class="breadcrumb mb-0 p-0">
							<li class="breadcrumb-item">
								<router-link to="/dashboard">
									<i class="bx bx-home-alt"></i>
								</router-link>
							</li>
							<li class="breadcrumb-item active" aria-current="page">Newsletter Banner CMS</li>
						</ol>
					</nav>
				</div>
			</div>
			<form @submit.prevent="updateCms()">
				<div class="card">
					<div class="card-body">
						<h5 class="card-title">Newsletter Banner CMS</h5>
						<hr />
						<div class="form-body mt-4">
							<div class="row">
								<div class="col-lg-8 mb-3">
									<div class="border border-3 p-4 rounded">
										<div class="row">
											<div class="col-12 mb-3">
												<label class="form-label">Title:</label>
												<input type="text" v-model="cmsData.title" class="form-control" placeholder="Enter title" />
											</div>
											<div class="col-12 mb-3">
												<label class="form-label">Subtitle:</label>
												<textarea type="text" v-model="cmsData.subTitle" class="form-control" placeholder="Enter subtitle" rows="5"></textarea>
											</div>
											<div class="col-12 mb-3">
												<label class="form-label">Search Box Text:</label>
												<input type="text" v-model="cmsData.searchBoxText" class="form-control" placeholder="Enter search box text"/>
											</div>
											<div class="col-12 mb-3">
												<label class="form-label">Button Text:</label>
												<input type="text" v-model="cmsData.buttonText" class="form-control" placeholder="Enter button text"/>
											</div>
										</div>
									</div>
								</div>
								<div class="d-grid col-12 col-lg-8">
									<button type="submit" class="btn btn-primary">Save</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script src="../js/newsletter-banner-page-cms.js"></script>